import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ButtonPrimary } from '../../../../../../utils/Button';
import { GetDate, GetTime } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-start h-auto',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(` text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item, initiate, implement, ongoing, done }) {
    const navigate = useNavigate();
    const [isTrActive, setIsTrActive] = useState(false);
    const handleRedirect = (e) => {
        e.stopPropagation();
        navigate(mkRelativeUrl(`/services/manage/${item?.id}/info`));
    };
    // const isActive = item?.status === 'active';
    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-92': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.serviceName}</span>
                </div>
                <div className="w-full hidden sm:block capitalize">
                    <span
                        className={item?.status === 'completed' ? 'text-secondary' : 'text-warning'}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard name="Customer Info" value={item?.customerInfo?.organization} />
                <TableInfoCard
                    name={initiate}
                    value={
                        <span>
                            {GetDate(item?.timeInitiate) || '-----'} <br />
                            <small>{GetTime(item?.timeInitiate)}</small>
                        </span>
                    }
                />

                <TableInfoCard
                    name={implement}
                    value={
                        <span>
                            {GetDate(item?.timeImplement) || '-----'} <br />
                            <small>{GetTime(item?.timeImplement)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name={ongoing}
                    value={
                        <span>
                            {GetDate(item?.timeOngoing) || '-----'} <br />
                            <small>{GetTime(item?.timeOngoing)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name={done}
                    value={
                        <span>
                            {GetDate(item?.timeDone) || '-----'} <br />
                            <small>{GetTime(item?.timeDone)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name="Updated At"
                    value={
                        <span>
                            {GetDate(item?.timeUpdated) || '-----'} <br />
                            <small>{GetTime(item?.timeUpdated)}</small>
                        </span>
                    }
                />
                <TableInfoCard
                    name="Status"
                    value={
                        <span
                            className={`${item?.status === 'completed' ? 'text-secondary' : 'text-warning'}`}
                        >
                            {item?.status}
                        </span>
                    }
                    className="visible sm:invisible"
                    isCapitalize
                />

                <div className="flex flex-row flex-wrap gap-px justify-end items-center">
                    <ButtonPrimary btnType="button" title="Manage" onClick={handleRedirect} />
                </div>
            </div>
        </div>
    );
}

function TableMobile({ data, initiate, implement, ongoing, done }) {
    return (
        <div className="service_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data?.services && data?.services?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.services?.map((item) => (
                        <TableRow
                            key={item.id}
                            item={item}
                            initiate={initiate}
                            implement={implement}
                            ongoing={ongoing}
                            done={done}
                        />
                    ))
                )}
            </div>
        </div>
    );
}

export default TableMobile;
